import React, { lazy, Suspense }  from 'react'
import ReactDOM from 'react-dom'

import Loader from '@components/shared/loader/loader'
const InstagramFeed = lazy(() => import('@components/instagram_feed/instagram_feed'))

document.addEventListener('DOMContentLoaded', () => {
  const elem = document.getElementById('instagram-feed');

  ReactDOM.render(
    <Suspense fallback={Loader()}>
      <InstagramFeed />
    </Suspense>,
    elem
  );
}, { once: true });
